<div class="flex flex-row w-full h-[75vh] gap-[12.5rem] baselayout-padding items-stretch">
  <div class="flex flex-col flex-grow">
    <div class="flex flex-col h-full">
      <div class="flex flex-row w-full mt-[3.125rem] mb-[3.125rem] justify-start items-center gap-[1.25rem]">
        <div>
          <p-menu #menu [model]="items" [popup]="true">
            <!--The following template is here so we can use Material Icons and PrimeNG Icons in this menu-->
            <ng-template #item let-item>
              <a pRipple class="flex items-center p-menu-item-link" [routerLink]="item.routerLink" [queryParams]="item.queryParams">
                @if (!hasMaterialIconClass(item)) {
                  <span [class]="item.icon"></span>
                }
                @if (hasMaterialIconClass(item)) {
                  <span [class]="item.iconClass">{{ item.icon }}</span>
                }
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </ng-template>
          </p-menu>
          <button pButton pRipple label="{{'New'|translate}}" icon="pi pi-plus"
                  (click)="menu.toggle($event)"></button>
        </div>
        <div class="w-full">
          <p-iconfield>
            <p-inputicon styleClass="pi pi-search"/>
            <p-autocomplete type="text" pSize="large" fluid
                            placeholder="{{'Search.Customers.Placeholder'|translate}}"
                            [suggestions]="customerNamesSuggestions" (completeMethod)="queryCustomerNames($event)"
                            field="name" (onSelect)="openCustomer($event)"
                            [emptyMessage]="'Search.Customers.EmptyMessage'|translate">
              <ng-template let-customer #item>
                <div class="flex items-center">
                  {{ getCustomerNameFromDto(customer) }}
                </div>
              </ng-template>
            </p-autocomplete>
          </p-iconfield>
        </div>
      </div>
      <div class="flex flex-col flex-grow justify-between gap-[3.125rem]">
        <div class="flex flex-row w-full justify-start items-start">
          <app-dashboard-treatments-list
            class="w-full"
            [titleKey]="'Dashboard.NextTreatments'"
            [emptyMessageKey]="'Dashboard.NoNextTreatments'"
            [treatments]="nextTreatments"
            [areTreatmentsLoaded]="areTreatmentsLoaded">
          </app-dashboard-treatments-list>
        </div>
        <div class="flex flex-row w-full justify-start items-start">
          <app-dashboard-treatments-list
            class="w-full"
            [titleKey]="'Dashboard.LastTreatments'"
            [emptyMessageKey]="'Dashboard.NoLastTreatments'"
            [treatments]="lastTreatments"
            [areTreatmentsLoaded]="areTreatmentsLoaded">
          </app-dashboard-treatments-list>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col items-stretch mt-[3.125rem]">
    <app-calendar-widget class="w-full"></app-calendar-widget>
  </div>
</div>
